import type { WhatsappTemplatesTranslations } from '../interfaces/whatsappTemplates';

export const whatsappTemplatesTranslations: WhatsappTemplatesTranslations = {
  page_title: 'Modelos do WhatsApp',
  page_subtitle:
    'Mensagens pré-aprovadas pela Meta. São as únicas que você pode enviar fora da janela de 24 horas.',
  new_template: 'Novo modelo',
  sync_from_meta: 'Sincronizar com a Meta',
  sync_success: '{{count}} modelos sincronizados da Meta',
  sync_empty: 'Não há modelos novos na Meta',
  search_placeholder: 'Buscar por nome…',

  column_name: 'Nome',
  column_category: 'Categoria',
  column_language: 'Idioma',
  column_status: 'Status',
  column_quality: 'Qualidade',
  column_updated: 'Atualizado',
  column_actions: 'Ações',

  filter_all: 'Todos',
  filter_approved: 'Aprovados',
  filter_pending: 'Em análise',
  filter_rejected: 'Rejeitados',

  status_APPROVED: 'Aprovado',
  status_IN_APPEAL: 'Em recurso',
  status_PENDING: 'Em análise',
  status_PENDING_DELETION: 'Excluindo',
  status_DELETED: 'Excluído',
  status_DISABLED: 'Desativado',
  status_LIMIT_EXCEEDED: 'Limite excedido',
  status_REJECTED: 'Rejeitado',
  status_PAUSED: 'Pausado',

  category_MARKETING: 'Marketing',
  category_UTILITY: 'Utilidade',
  category_AUTHENTICATION: 'Autenticação',
  category_MARKETING_hint:
    'Promoções, novidades e recuperação de carrinho. Exige que o cliente tenha aceitado recebê-las.',
  category_UTILITY_hint:
    'Confirmações de pedido, envios, lembretes de agendamento. É a categoria mais fácil de aprovar.',
  category_AUTHENTICATION_hint:
    'Códigos de uso único. A Meta exige um formato fixo que ainda não suportamos.',

  empty_title: 'Você ainda não tem modelos',
  empty_description:
    'Crie seu primeiro modelo ou traga os que já existem na sua conta da Meta.',
  empty_action: 'Criar modelo',
  not_connected_title: 'Conecte o WhatsApp primeiro',
  not_connected_description:
    'Os modelos ficam na sua conta do WhatsApp Business. Conecte-a para vê-los e criá-los aqui.',
  not_connected_action: 'Ir para integrações',
  no_business_id_title: 'Faltam dados da sua conta da Meta',
  no_business_id_description:
    'Sua conta foi conectada antes de guardarmos o identificador do portfólio de negócios, que a Meta exige para gerenciar modelos. Reconecte o WhatsApp para completá-lo.',
  no_business_id_action: 'Reconectar',
  rejected_reason_label: 'Motivo da rejeição',

  action_edit: 'Editar',
  action_send: 'Enviar',
  action_duplicate: 'Duplicar',
  action_delete: 'Excluir',

  delete_title: 'Excluir modelo',
  delete_description:
    'Excluir “{{name}}”? Esta ação não pode ser desfeita.',
  delete_all_languages_warning:
    'A Meta exclui por nome: todas as versões de idioma deste modelo serão removidas.',
  delete_confirm: 'Excluir',
  delete_cancel: 'Cancelar',
  delete_success: 'Modelo excluído',

  editor_create_title: 'Novo modelo',
  editor_edit_title: 'Editar modelo',
  editor_save: 'Salvar e enviar à Meta',
  editor_cancel: 'Cancelar',
  editor_create_success: 'Modelo enviado para análise da Meta',
  editor_update_success: 'Modelo atualizado e reenviado para análise',
  editor_readonly_notice:
    'Este modelo não pode ser editado no estado atual.',

  section_identity: 'Identidade',
  section_identity_hint:
    'A Meta congela estes campos na criação; depois só o conteúdo pode mudar.',
  field_name: 'Nome',
  field_name_hint: 'Apenas minúsculas, números e sublinhados.',
  field_name_preview: 'Será criado como:',
  field_category: 'Categoria',
  field_language: 'Idioma',
  field_parameter_format: 'Formato das variáveis',
  format_positional: 'Numeradas · {{sample}}',
  format_named: 'Com nome · {{sample}}',
  format_hint: 'Não pode ser alterado depois de criar o modelo.',
  identity_locked_notice:
    'A Meta não permite alterar o nome, a categoria nem o idioma de um modelo existente.',

  section_header: 'Cabeçalho',
  section_header_hint: 'Opcional. Uma linha curta em negrito acima da mensagem.',
  header_kind_NONE: 'Sem cabeçalho',
  header_kind_TEXT: 'Texto',
  header_kind_IMAGE: 'Imagem',
  header_kind_VIDEO: 'Vídeo',
  header_kind_DOCUMENT: 'Documento',
  header_kind_LOCATION: 'Localização',
  header_media_unavailable:
    'Cabeçalhos com mídia ainda não podem ser criados no {{brand}}.',
  header_preserved_notice:
    'Este modelo usa um cabeçalho que não pode ser editado aqui. Ele será mantido como está ao salvar.',
  field_header_text: 'Texto do cabeçalho',

  section_body: 'Mensagem',
  section_body_hint:
    'O corpo da mensagem. Use variáveis para personalizá-la por cliente.',
  field_body_text: 'Texto da mensagem',
  add_variable: 'Adicionar variável',
  renumber_variables: 'Renumerar variáveis',
  renumber_hint:
    'As variáveis numeradas devem ir de 1 em diante sem saltos. A Meta rejeita o modelo se faltar alguma.',

  section_footer: 'Rodapé',
  section_footer_hint: 'Opcional. Texto pequeno e cinza abaixo da mensagem.',
  footer_enable: 'Adicionar rodapé',
  field_footer_text: 'Texto do rodapé',

  section_buttons: 'Botões',
  section_buttons_hint: 'Opcional. Até 3 botões.',
  add_button: 'Adicionar botão',
  button_type_QUICK_REPLY: 'Resposta rápida',
  button_type_URL: 'Abrir link',
  button_type_PHONE_NUMBER: 'Ligar',
  field_button_text: 'Texto do botão',
  field_button_url: 'Link',
  field_button_phone: 'Telefone',
  button_move_up: 'Subir',
  button_move_down: 'Descer',
  button_remove: 'Remover botão',

  section_variables: 'Exemplos das variáveis',
  variables_required_notice:
    'A Meta rejeita modelos cujas variáveis não têm um valor de exemplo. Eles servem só para a análise e nunca são enviados aos seus clientes.',
  variables_empty:
    'Esta mensagem não tem variáveis. Digite {{sample}} no texto para adicionar uma.',
  field_example_value: 'Valor de exemplo',
  variable_label: 'Variável',

  preview_title: 'Pré-visualização',
  preview_empty: 'Escreva a mensagem para ver a pré-visualização.',

  confirm_edit_title: 'Editar um modelo aprovado',
  confirm_edit_description:
    'Ao salvar, este modelo volta para análise da Meta e não poderá ser enviado até ser aprovado de novo.',
  confirm_edit_accept: 'Entendi, salvar',
  confirm_edit_cancel: 'Cancelar',

  validation_name_required: 'Escreva um nome',
  validation_name_format: 'Apenas minúsculas, números e sublinhados',
  validation_name_hex24:
    'Este nome conflita com o formato de identificador interno. Adicione ou remova um caractere.',
  validation_name_duplicate: 'Você já tem um modelo com este nome e idioma',
  validation_body_required: 'A mensagem não pode ficar vazia',
  validation_body_max: 'Máximo de 1024 caracteres',
  validation_footer_max: 'Máximo de 60 caracteres',
  validation_header_max: 'Máximo de 60 caracteres',
  validation_example_required: 'A Meta exige um exemplo para cada variável',
  validation_positional_gap:
    'As variáveis devem ir de 1 em diante sem saltos',
  validation_named_format:
    'As variáveis com nome devem começar por uma letra minúscula e usar apenas letras, números e sublinhados',
  validation_edge_variable:
    'A mensagem não pode começar nem terminar com uma variável',
  validation_adjacent_variables: 'Duas variáveis não podem ficar juntas',
  validation_footer_no_variables: 'O rodapé não aceita variáveis',
  validation_header_one_variable:
    'O cabeçalho aceita no máximo uma variável',
  validation_button_text_required: 'Escreva o texto do botão',
  validation_button_url: 'Escreva um link válido',
  validation_button_phone: 'Escreva um telefone em formato internacional',
  validation_buttons_max: 'Máximo de 3 botões',
  validation_url_buttons_max: 'Máximo de 2 botões de link',
  validation_phone_buttons_max: 'Máximo de 1 botão de ligação',
  validation_wrong_format_tokens:
    'Este modelo usa variáveis {{format}}. Use esse formato ou a Meta não vai detectá-las.',

  send_title: 'Enviar modelo',
  send_description:
    'Enviado do seu número do WhatsApp Business, direto no chat do cliente.',
  send_template_label: 'Modelo',
  send_template_placeholder: 'Escolha um modelo aprovado',
  send_from_label: 'Enviar de',
  send_to_label: 'Enviar para',
  send_to_placeholder: '+57 319 684 4292',
  send_to_invalid: 'Inclua o código do país, por exemplo +57 319 684 4292',
  send_fill_examples: 'Preencher com os exemplos',
  send_submit: 'Enviar',
  send_cancel: 'Cancelar',
  send_success: 'Mensagem enviada',
  send_no_approved_title: 'Você não tem modelos aprovados',
  send_no_approved_description:
    'Só é possível enviar modelos que a Meta já aprovou.',
  send_no_approved_action: 'Ver modelos',
  send_media_link_label: 'Link do arquivo',
  send_media_link_hint:
    'Este modelo tem mídia no cabeçalho. Cole um link público para o arquivo.',
  send_variables_title: 'Variáveis',

  error_UNAUTHORIZED: 'Sua sessão expirou. Entre novamente.',
  error_FORBIDDEN:
    'Seu perfil não tem permissões sobre modelos do WhatsApp. Peça a um administrador.',
  error_NOT_FOUND: 'Modelo não encontrado',
  error_VALIDATION: 'A Meta rejeitou os dados: {{detail}}',
  error_NO_WABA_TOKEN:
    'Sua organização ainda não tem o WhatsApp conectado. Conecte em Configurações → Integrações.',
  error_TEMPLATE_EXISTS: 'Já existe um modelo com esse nome e idioma',
  error_META_REJECTED: 'A Meta rejeitou a solicitação: {{detail}}',
  error_UNKNOWN: 'Algo deu errado: {{detail}}',
};
